var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qrcode"},[_c('img',{attrs:{"src":_vm.currentImg,"alt":_vm.$t('contact.title')}})])}
var staticRenderFns = []

export { render, staticRenderFns }